import React from 'react'
import styles from '../OurCompany/OurCompany.module.css'
import { useNavigate } from "react-router-dom";

const OurCompany = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className={styles.BackBtnDiv}>
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <svg
            width="18"
            height="15"
            viewBox="0 0 18 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.252011 8.20052L5.8383 14.6871C6.15713 15.0254 6.82754 15.1466 7.19124 14.759C7.55373 14.3848 7.55373 13.6604 7.19124 13.2729L3.08873 8.52662L17.0653 8.52662C17.5818 8.52662 18 8.06717 18 7.49988C18 6.9326 17.5817 6.47315 17.0653 6.47315L3.08873 6.47315L7.19 1.72555C7.55249 1.35132 7.57431 0.589615 7.19 0.239358C6.82751 -0.086909 6.16681 -0.098897 5.83706 0.323253L0.252011 6.79793C0.00955088 7.06428 -0.166247 7.75277 0.252011 8.1989V8.20052Z"
              fill="currentColor"
            />
          </svg>
          <h4>Back</h4>
        </div>
      </div>

      <div className={styles.containerBox}>
        <div className={styles.container}>
          <div className={styles.LeftSection}>
            <div className={styles.eyeforwarImg}>
              <img src='Images/climbing-girl.webp' alt='climbing-girl' loading="lazy" decoding="async" />

            </div>
          </div>
          <div className={styles.RightSection}>
            <div className={styles.Content}>

              <div className={styles.bredcrumMain} >
                <div className={styles.bredcrum}>
                  <h5 className={styles.Rightheading}>Our Company</h5>
                </div>

              </div>
              <h1 className={styles.title}>Bruno Vision Care</h1>
              <h3 className={styles.subtitle}>Delivering the future of eye health</h3>

              <div className={styles.descriptions}>
                <p className={styles.dsec}>
                  Bruno Vision Care was established in 2019 as a subsidiary of Bruno Farmaceutici, Italy’s third-largest pharmaceutical company. Our foundation is built on more than a decade of scientific innovation, beginning with the development of FusionTechnology™ in 2011; a breakthrough that combines the synergistic actions of HA and TSP to mimic natural tears.</p>
                <p className={styles.dsec}>This work led to the development of
                  our novel hydrogel material, vifilcon C, which incorporates FusionTechnology and received
                  FDA clearance in Deseyne® brand contact lenses for the correction of myopia, hyperopia,
                  and astigmatism on October 25, 2024. We are continuing to advance FusionTechnology as a
                  proprietary materials platform with broader applications in ocular health.</p>

              </div>
            </div>

          </div>

        </div>
        <div className={styles.trackingDiv}>
          <img src='Images/old-men.png' alt='old-men' loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
  )
}

export default OurCompany
